import { combineReducers } from "redux";
import booksReducer from "./features/Book/reducer";
import searchReducer from "./features/Search/reducer";

export default combineReducers({
  book: booksReducer,
  search: searchReducer,
});
